import { css } from "@emotion/css";
import type { IconSize } from "@octopusdeploy/design-system-icons";
import { getIconStyles } from "../utils";
type NumericIconSize = Exclude<IconSize, "font-size">;
/**
 * Fallback icon for tenant avatars.
 * This does not use an icon from the Design System Icon package.
 * It is a custom SVG to match the existing user selected icons. Eventually we would like to replace this with a Design System Icon.
 * It has not been added to the package because it is not an icon we would like people to use outside of the tenant avatar.
 */
export interface AvatarFallbackTenantIconProps {
    size: NumericIconSize;
}
export function AvatarFallbackTenantIcon({ size }: AvatarFallbackTenantIconProps) {
    const iconStyles = getIconStyles(size);
    return (<div className={iconStyles}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" role="img" aria-label="Tenant Icon" className={iconSvgStyles}>
                <path fill="currentColor" d="M13 .17a12.83 12.83 0 1 0 0 25.66A12.83 12.83 0 0 0 13 .17Zm0 3.85a3.84 3.84 0 1 1 .01 7.69A3.84 3.84 0 0 1 13 4.02Zm0 18.21a9.23 9.23 0 0 1-7.7-4.13c.04-2.55 5.13-3.95 7.7-3.95 2.55 0 7.66 1.4 7.7 3.95a9.23 9.23 0 0 1-7.7 4.13Z"/>
            </svg>
        </div>);
}
// Added in to address some alignment issues with SVGs in some locations within the application
// due to inheritence problems from the parent CSS.
const iconSvgStyles = css({
    display: "block",
});
